import React from "react";
import { FormControl, TextField, Autocomplete, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../components.scss";

interface CompanySelectProps {
  value: any;
  onChange: (value: number | string | null) => void;
  companyNames: { id: number | string; company_name: string }[];
  disabled?: boolean;
  touched?: boolean;
  error?: any;
  isLabelled?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  borderRequired?: boolean;
}

const CompanySelect: React.FC<CompanySelectProps> = ({
  value,
  onChange,
  companyNames,
  disabled,
  touched,
  error,
  isLabelled,
  isRequired = false,
  placeholder,
  borderRequired = false,
}) => {
  const selectedCompany =
    companyNames.length > 0 && typeof value === "object" && value !== null
      ? companyNames.find((company) => company.id === value.id) || null
      : typeof value === "number" ||
          (typeof value === "string" && value !== null)
        ? companyNames.find((company) => company.id === value) || null
        : value;
  return (
    <FormControl
      fullWidth
      disabled={disabled}
      error={touched && !!error}
      className="user-management-select"
    >
      {isLabelled && (
        <label htmlFor="company-select" className="form-label">
          Company{isRequired && <span className="required-asterisk">*</span>}
        </label>
      )}
      <Autocomplete
        id="company-select"
        options={companyNames}
        getOptionLabel={(option) => option.company_name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={selectedCompany}
        onChange={(_, newValue) => onChange(newValue?.id || null)}
        disabled={disabled}
        popupIcon={<ExpandMoreIcon />}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select a company"
            error={touched && !!error}
            helperText={touched && error}
            InputLabelProps={{ shrink: false }}
            style={borderRequired ? { borderTop: "2px solid #e30000", borderTopRightRadius:"4px", borderTopLeftRadius: "4px" } : undefined}
          />
        )}
        sx={{
          "& .MuiOutlinedInput-root": {
            paddingRight: 0,
            paddingLeft: "9px",
            padding: 0,
          },
        }}
      />
    </FormControl>
  );
};

export default CompanySelect;
